module.exports = __webpack_public_path__ + "static/TuanTran-9e66907f56feda8db1a92ea83bece0db.svg";